/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePLanRequestPaymentFrequency
 */
export interface UpdatePLanRequestPaymentFrequency {
}

/**
 * Check if a given object implements the UpdatePLanRequestPaymentFrequency interface.
 */
export function instanceOfUpdatePLanRequestPaymentFrequency(value: object): value is UpdatePLanRequestPaymentFrequency {
    return true;
}

export function UpdatePLanRequestPaymentFrequencyFromJSON(json: any): UpdatePLanRequestPaymentFrequency {
    return UpdatePLanRequestPaymentFrequencyFromJSONTyped(json, false);
}

export function UpdatePLanRequestPaymentFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePLanRequestPaymentFrequency {
    return json;
}

export function UpdatePLanRequestPaymentFrequencyToJSON(json: any): UpdatePLanRequestPaymentFrequency {
    return UpdatePLanRequestPaymentFrequencyToJSONTyped(json, false);
}

export function UpdatePLanRequestPaymentFrequencyToJSONTyped(value?: UpdatePLanRequestPaymentFrequency | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

